export function darkenColor(color: string, amount = 0.2): string {
  // Convert hex to RGB
  const hex = color.replace('#', '');
  const red = parseInt(hex.substring(0, 2), 16);
  const green = parseInt(hex.substring(2, 4), 16);
  const blue = parseInt(hex.substring(4, 6), 16);

  // Convert RGB to HSL
  const rNorm = red / 255;
  const gNorm = green / 255;
  const bNorm = blue / 255;

  const max = Math.max(rNorm, gNorm, bNorm);
  const min = Math.min(rNorm, gNorm, bNorm);
  let hue = 0;
  let saturation = 0;
  let lightness = (max + min) / 2;

  if (max !== min) {
    const delta = max - min;
    saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);

    switch (max) {
      case rNorm:
        hue = ((gNorm - bNorm) / delta + (gNorm < bNorm ? 6 : 0)) / 6;
        break;
      case gNorm:
        hue = ((bNorm - rNorm) / delta + 2) / 6;
        break;
      case bNorm:
        hue = ((rNorm - gNorm) / delta + 4) / 6;
        break;
      default:
        break;
    }
  }

  // Darken by reducing lightness
  lightness = Math.max(0, lightness - amount);

  // Convert HSL back to RGB
  const hslToRgb = (hueVal: number, satVal: number, lightVal: number) => {
    let redVal;
    let greenVal;
    let blueVal;

    if (satVal === 0) {
      redVal = lightVal;
      greenVal = lightVal;
      blueVal = lightVal;
    } else {
      const hue2rgb = (p: number, q: number, tVal: number) => {
        let t = tVal;
        if (t < 0) {
          t += 1;
        }
        if (t > 1) {
          t -= 1;
        }
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      };

      const q = lightVal < 0.5 ? lightVal * (1 + satVal) : lightVal + satVal - lightVal * satVal;
      const p = 2 * lightVal - q;

      redVal = hue2rgb(p, q, hueVal + 1 / 3);
      greenVal = hue2rgb(p, q, hueVal);
      blueVal = hue2rgb(p, q, hueVal - 1 / 3);
    }

    return [Math.round(redVal * 255), Math.round(greenVal * 255), Math.round(blueVal * 255)];
  };

  const [newR, newG, newB] = hslToRgb(hue, saturation, lightness);

  // Convert back to hex
  const toHex = (n: number) => n.toString(16).padStart(2, '0');

  return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
}
